export const printTemplatePrefix = 'printTemplate_$';
export const printTemplatePdfPrefix = 'printTemplate_pdf_$';
